// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table.table--sortable .table-body .table-body__row > .table-body__cell {
  cursor: default;
}

.drag-handle {
  cursor: move;
}

.drag-handle.thick {
  width: 20px;
}

.panel-email-login.visible {
  height: 430px;
  opacity: 1;
  transition: all 0.8s;
}

.auth-form .form-group {
  text-align: left;
}

fieldset,
legend {
  border: 0;
  padding: 0;
}

legend {
  border-bottom: 1px solid #e5e5e5;
  display: block;
  font-size: 21px;
  line-height: inherit;
  margin-bottom: 20px;
  width: 100%;
}

.financial-selector.financial-selector--login.is-email-login {
  background-color: #bcbcbc;
}

.menu-link {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".table.table--sortable .table-body .table-body__row > .table-body__cell {\n  cursor: default;\n}\n\n.drag-handle {\n  cursor: move;\n}\n\n.drag-handle.thick {\n  width: 20px;\n}\n\n.panel-email-login.visible {\n  height: 430px;\n  opacity: 1;\n  transition: all 0.8s;\n}\n\n.auth-form .form-group {\n  text-align: left;\n}\n\nfieldset,\nlegend {\n  border: 0;\n  padding: 0;\n}\n\nlegend {\n  border-bottom: 1px solid #e5e5e5;\n  display: block;\n  font-size: 21px;\n  line-height: inherit;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.financial-selector.financial-selector--login.is-email-login {\n  background-color: #bcbcbc;\n}\n\n.menu-link {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
